/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import {
  EntityFilter,
  EntityTextFilter,
} from '@backstage/plugin-catalog-react';

export interface CatalogFilters {
  filter: Record<string, string | symbol | (string | symbol)[]>;
  fullTextFilter?: {
    term: string;
  };
}

function isEntityTextFilter(t: EntityFilter): t is EntityTextFilter {
  // @ts-ignore as sonar scan giving issue if we type cast
  return !!t.getFullTextFilters;
}

export function reduceCatalogFilters(filters: EntityFilter[]): CatalogFilters {
  const condensedFilters = filters.reduce<CatalogFilters['filter']>(
    (compoundFilter, filter) => {
      return {
        ...compoundFilter,
        ...(filter.getCatalogFilters ? filter.getCatalogFilters() : {}),
      };
    },
    {},
  );

  const textFilter = filters.find(isEntityTextFilter);
  const fullTextFilter = (textFilter as EntityTextFilter)?.getFullTextFilters();
  return { filter: condensedFilters, fullTextFilter };
}
